import { Container } from "react-bootstrap";
import { Form } from "@/ui/Form";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { useLink } from "@/hooks/useLink";

export const FormSection = ({ className, title, content, form, successPageUrl }) => {
  const link = useLink();

  const onSubmitDone = () => {
    if (typeof window !== "undefined") {
      window.location.href = successPageUrl;
    }
  };

  return (
    <div className={className}>
      <Container className="px-0">
        <div className={clsx(classes.form, "p-4 p-md-5")}>
          <h4 className="mb-2">{title}</h4>
          <div className="mb-4" dangerouslySetInnerHTML={{ __html: content }} />

          <Form formId={form} onSubmitDone={onSubmitDone} />
        </div>
      </Container>
    </div>
  );
};

export default FormSection;
